import React, { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PlatformMessageTemplate } from "../../../cores/platformAutomations/services/api";
import { computeTimeline } from "../../../cores/platformAutomations/utils/draftDefinition.utils";
import { PlatformAutomationDraft } from "../../../cores/platformAutomations/types";

type Props = {
  draft: PlatformAutomationDraft;
  templates: PlatformMessageTemplate[];
};

export default function PlatformAutomationTimeline({ draft, templates }: Props) {
  const templateMap = useMemo(
    () =>
      templates.reduce<Record<number, { name: string; subject?: string }>>(
        (acc, t) => {
          acc[t.id] = {
            name: t.name,
            subject: t.draftDefinition?.subject,
          };
          return acc;
        },
        {}
      ),
    [templates]
  );

  const timeline = useMemo(
    () => computeTimeline(draft.steps || [], templateMap),
    [draft.steps, templateMap]
  );

  if (!timeline.length) return null;

  return (
    <div className="pa-timeline">
      <h5 className="pa-timeline__title">
        <FontAwesomeIcon icon={["fas", "calendar-days"]} /> Vista previa del journey
      </h5>
      <div className="pa-timeline__scroll" tabIndex={0} aria-label="Vista previa del journey">
        <div className="pa-timeline__track">
          {timeline.map((item, index) => (
            <React.Fragment key={item.stepId}>
              <div className="pa-timeline__item">
            <div className="pa-timeline__day">
              <span>{item.offsetLabel}</span>
            </div>
                <div
                  className={`pa-timeline__card pa-timeline__card--${item.type}`}
                  title={item.label}
                >
                  <FontAwesomeIcon
                    icon={
                      item.type === "delay"
                        ? ["fas", "clock"]
                        : ["fas", "envelope-open-text"]
                    }
                  />
                  <div className="pa-timeline__card-copy">
                    <strong>{item.label}</strong>
                    {item.detail && <span>{item.detail}</span>}
                  </div>
                </div>
              </div>
              {index < timeline.length - 1 && (
                <div className="pa-timeline__arrow" aria-hidden="true">
                  <FontAwesomeIcon icon={["fas", "chevron-right"]} />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
